import React from 'react'
import { t } from 'ttag'

import Form from '../../form/Form'
import Field from '../../form/Field'
import * as v from '../../form/validations'

const SurveyCreationForm = ({ onSave, onCancel, canCreateShared }) => {
  const formModel = 'survey.surveyForms.createSurveyForm'
  const model = path => `${formModel}.${path}`

  return (
    <Form
      model={formModel}
      onSubmit={form => {
        onSave(form)
      }}
      validate={{
        email: [v.targetField('ccResponsesTo', v.email())]
      }}>
      {form => (
        <div>
          <Field
            model={model(`name`)}
            form={form}
            required={true}
            label={t`Survey Name`}
            type="text"
          />

          <Field
            model={model(`description`)}
            form={form}
            label={t`Description`}
            type="textarea"
          />

          <Field
            model={model(`confirmationText`)}
            form={form}
            label={t`Confirmation text to display on submission (leave blank for default)`}
            type="textarea"
          />

          {canCreateShared ? (
            <Field
              model={model(`shared`)}
              form={form}
              label={t`Shared Survey`}
              type="checkbox"
            />
          ) : null}

          <Field
            model={model(`oncePerUser`)}
            form={form}
            label={t`Users can only answer once (requires users be logged in to complete)`}
            type="checkbox"
          />

          <Field
            model={model(`customButtonText`)}
            form={form}
            label={t`Button Text`}
            type="text"
          />

          <Field
            model={model(`ccResponsesTo`)}
            form={form}
            label={t`CC Responses To`}
            type="text"
          />

          <div className="nav" style={{ marginTop: '1em' }}>
            <input type="submit" className="submit" value={t`Submit`} />
            &nbsp;
            <button type="button" onClick={onCancel} className="cancel">
              {t`Cancel`}
            </button>
          </div>
        </div>
      )}
    </Form>
  )
}

export default SurveyCreationForm
